import { Field, useFormikContext } from 'formik'
import React from 'react'

import { InnerField } from '@components/common/InnerField'
import { Checkbox, Fieldset, InputUI, RadioButton } from '@fourthwall/components'
import type { MembershipTier } from '@fourthwall/services/dist/MembershipsApiClient'

import type { ProductFormState } from '../../SingleProduct.types'
import * as S from './styled'

type Props = {
  membershipTiers?: MembershipTier[]
  disabled?: boolean
}

export const ProductMembershipSettings = ({ membershipTiers, disabled = false }: Props) => {
  const { values, errors, touched } = useFormikContext<ProductFormState>()

  const renderMembersOnlyTiers = () => {
    if (values.membersOnlyType !== 'SELECTED_TIERS') {
      return null
    }

    return (
      <>
        {membershipTiers?.map((tier) => (
          <InnerField key={tier.id}>
            <InnerField fluid>
              <Field
                component={Checkbox}
                name={`membersOnlyTierIds[${tier.id}]`}
                label={tier.name}
                disabled={disabled}
              />
            </InnerField>
          </InnerField>
        ))}
        <InnerField fluid>
          {errors.membersOnlyTierIds && touched.membersOnlyTierIds && (
            // @ts-ignore
            <InputUI.Error>{errors.membersOnlyTierIds}</InputUI.Error>
          )}
        </InnerField>
      </>
    )
  }

  const renderMembersOnlyType = () => {
    if (!values.withMembersOnly) {
      return null
    }

    return (
      <S.RadioWrapper>
        <InnerField fluid>
          <Field
            component={RadioButton}
            name="membersOnlyType"
            checkedValue="ALL_TIERS"
            label="All tiers"
            disabled={disabled}
          />
        </InnerField>
        <InnerField fluid>
          <Field
            component={RadioButton}
            name="membersOnlyType"
            checkedValue="SELECTED_TIERS"
            label="Selected tiers"
            disabled={disabled}
          />
        </InnerField>

        {renderMembersOnlyTiers()}
      </S.RadioWrapper>
    )
  }

  if (!membershipTiers?.length) {
    return null
  }

  return (
    <S.Wrapper>
      <Fieldset.Row>
        <Field
          component={Checkbox}
          name="withMembersOnly"
          label="Make this a members-only product"
          disabled={disabled}
        />
      </Fieldset.Row>
      {renderMembersOnlyType()}
    </S.Wrapper>
  )
}
